import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import rem from './utils/rem'
import base from './utils'
import { $get, $post } from '@/api/request'
import Element from 'element-ui'
import conf from './config'
import './styles/common.scss'
import './styles/element-variables.scss'
import '@/assets/fonts/iconfont.css'
import VueQuillEditor from '@/assets/vue-quill-editor'
// import VueQuillEditor from 'vue-quill-editor'
// require styles
// import '@/assets/quill/dist/quill.core.css'
// import '@/assets/quill/dist/quill.snow.css'
// import '@/assets/quill/dist/quill.bubble.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import Quill from '@/assets/quill/dist/quill'
import VueClipboard from 'vue-clipboard2'
// import Print from 'vue-print-nb'
// import Print from './utils/print'
// import Print from './utils/vue-print-nb/src/printarea'
import Print from 'vue-print-nb'
import { remToPx } from '@/utils/util'
import Dialog from '@/components/Dialog/index.js'
import approvalRadio from '@/components/approvalRadio'
import VueBarcode from 'vue-barcode';
Vue.component('barcode', VueBarcode)
Vue.component('approvalRadio', approvalRadio)
Vue.use(Dialog)
Vue.prototype.$remToPx = remToPx
// 引入‘打印’组件
Vue.use(Print)

Vue.use(VueClipboard)

Vue.use(VueQuillEditor)

Element.Dialog.props.closeOnClickModal.default = false
Vue.use(Element, {})
// 需要时引入mock
// process.env.VUE_APP_MOCK && require('./mock')

Vue.config.productionTip = false
Vue.prototype.$base = base()
Vue.prototype.$conf = conf
// Vue.prototype.$print = Print // 打印

Object.assign(Vue.prototype, {
  $get
})
Object.assign(Vue.prototype, {
  $post
})

rem()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
